export class StringDate {

  constructor(public date?: string, public time?: string) {
    if (!date) {
      date = '0000-01-01';
    }
    if (!time) {
      time = '00:00';
    }
  }

  setDate(date: Date): StringDate {
    this.date = [
      date.getFullYear(),
      this.pad(String(date.getMonth() + 1)),
      date.getDate()
    ].join('-');

    this.time = [
      this.pad(String(date.getHours())),
      this.pad(String(date.getMinutes()))
    ].join(':');

    return this;
  }

  toDate(): Date {
    return new Date(this.date + ' ' + this.pad(this.time));
  }

  private pad(subject: string) {
    let width = 2;
    let char = '0';
    if (subject.length >= width) {
      return subject;
    }
    return new Array(width - subject.length + 1).join(char) + subject;
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/date/stringdate.ts
 **/